var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.refreshDom)?_c('div',{staticClass:"login-page"},[_c('img',{staticClass:"login-bg",attrs:{"src":_vm.file[_vm.fileId]}}),_c('LoginCard')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }